<template>
<!-- 修改注册的门店信息 -->
  <div>
      <el-form >
          <el-form-item label="手机号">
              <el-input v-model="mobliePhone"></el-input>
          </el-form-item>
      </el-form>
      <el-form :model="editForm" >

      </el-form>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/baseStore/baseRests.vue